import { Typography, Grid } from '@mui/material';
import { GridOverlay } from '@mui/x-data-grid';
import { useTranslation } from 'react-i18next';

// overlay for no rows with search term
const CustomNoRowsOverlay = () => {
  const { t } = useTranslation();

  return (
    <GridOverlay>
      <Grid display="flex" flexDirection="column" alignItems="center">
        <img src="/assets/icons/sad-circle.svg" alt="sad-circle" />
        <Typography variant="title2Bold" color="primary">
          {t('common.noResultsFound')}!
        </Typography>
      </Grid>
    </GridOverlay>
  );
};

export default CustomNoRowsOverlay;
